import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Link } from "react-router-dom";
import classNames from "classnames";
import { Row, Col } from "reactstrap";
import ReactLoading from "react-loading";
import withScrollTo from "../hoc/withScrollTo";
import { getQueryParamsUrl } from "../../helpers/url";
import { Container, Box, Text } from "../PagePaymentResult/styled";
import Header from "../PagePaymentResult/Header";
import Content from "../PagePaymentResult/Content";
import Icon from "./Icon";
import { isFromKickApp } from "../../utils";
import moment from "moment";
import axios from "axios";
import { API_BASE_URL } from "../../constants";
import kredivoDeclined from '../../images/kredivo-payment-declined.png';
import PendingIcon from '../../images/icons/pending.png';
import ErrorIcon from '../../images/kredivo-payment-declined.png';
// import TimesUpIcon from '../../images/icons/times-up.png';
import SuccessIcon from '../../images/kick-credit-payment-success.jpg';

const akulakuIcon =
  "https://kickavenue-assets.s3-ap-southeast-1.amazonaws.com/assets-image/akulaku-logo.png";

const NOT_FOUND = "/404";
const HOME_ROUTE = "/";

const getStatusText = status => {
  switch (Number(status)) {
    case 1:
      return "Waiting your payment confirmation.";
    case 101: //receipted
    case 100:
      return "Your payment has been paid successfully.";
    case 91:
      return "Your payment has been refunded.";
    case 92:
      return "Your payment has been cancelled.";
    default:
      return "We got something issues when processing your payment.";
  }
};

class PagePaymentAkulaku extends Component {
  constructor(props) {
    super(props);
    //appId=90824769&refNo=KA-190420-NBK-HRG&sign=CSZtWnm7iRsFWFpp4egEoZzg2Pe6CBTatsOPoNcLkF3Ae7HmCtFxllnKokB9ul94h03JFEXsBAXHwuWet_ryxw
    // console.log("INI STATE: ", getQueryParamsUrl(props.location.search));
    const params = Object.assign(
      {
        appId: null,
        refNo: null,
        sign: null
      },
      getQueryParamsUrl(props.location.search)
    );

    this.state = {
      params: { ...params },
      data: null,
      pingThreshold: 100, //one hundred times
      pingCount: 0,
      status: "1",
      timer: null,
      isFetchAkulaku: false,
      totalAmount: null
    };
    this._handleGoHome = this._handleGoHome.bind(this);
    // console.log("INI SEBELUM PARSE: ", props.location.search);
    // console.log("INI STATE: ", getQueryParamsUrl(props.location.search));
    // console.log("INI STATE: ", this.state);
  }
  componentDidMount() {
    const { appId, refNo, sign } = this.state.params;
    if (!(appId && refNo && sign)) {
      this.props.history.replace(NOT_FOUND);
    }
    // else
    // this._validateResponse();
    this.getAkulakuDetails();
  }

  componentDidUpdate(_p, prevState) {
    if (prevState.isFetchAkulaku && !this.state.isFetchAkulaku) {
      const { pingCount, pingThreshold, status } = this.state;
      if (pingCount < pingThreshold && status == 1) {
        setTimeout(() => {
          // console.log("Start refetch: ", pingCount);
          this.getAkulakuDetails();
        }, 15000);
      }
    }
  }

  getAkulakuDetails = () => {
    const { refNo } = this.state.params;
    this.setState(
      {
        isFetchAkulaku: true
      },
      () => {
        axios
          .post(`${API_BASE_URL}/akulaku/status`, { invoice_number: refNo })
          .then(resp => {
            // console.log('log: ', resp.data);
            const { data } = resp.data;
            this.setState({
              isFetchAkulaku: false,
              pingCount: this.state.pingCount + 1,
              status: data.status,
              totalAmount: data.total_price,
              timer: !this.state.pingCount
                ? moment()
                  .add(5, "minutes")
                  .format("YYYY-MM-DD HH:mm:ss")
                : this.state.timer
            });
          })
          .catch(e => {
            // console.error('Error: ', e.response.data);
            if (e.response && e.response.data) {
              const { status_code } = e.response.data.error;
              if (status_code === 404) {
                this.props.history.replace(NOT_FOUND);
              }
            }
            this.setState({
              isFetchAkulaku: false,
              pingCount: this.state.pingCount + 1,
              status: "999"
            });
          });
      }
    );
  };

  _handleGoHome(e) {
    // e.preventDefault();
    this.props.history.push(HOME_ROUTE);
  }

  _handleOnCompleteTimer = () => {
    const { status } = this.state;
    //re-run the timer...
    if (status == 1) {
      this.setState(
        {
          pingCount: 0,
          timer: null
        },
        () => this.getAkulakuDetails()
      );
    }
  };

  getStatusIcon = (status) => {
    switch (status) {
      case 'PROCESSING': return PendingIcon;
      case 'PAID': return SuccessIcon;
      default: return ErrorIcon;
    }
  }

  render() {
    return (
      <>
        {/* <Container className="main-container page-container">
          <Row>
            <Col>
              <Box>
                <div
                  className={classNames({ "d-none": this.state.status != 1 })}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                  }}
                >
                  <ReactLoading
                    type={"spin"}
                    height={20}
                    width={20}
                    color="#159953"
                  />
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <KickImage
                    src={akulakuIcon}
                    width={100}
                    alt="Buy Now, Pay Later with Akulaku"
                    style={{ margin: "20px auto" }}
                  />
                </div>
                <Header title={`${getStatusText(this.state.status)}`} />
                <Icon
                  status={this.state.status}
                  timer={this.state.timer}
                  onComplete={this._handleOnCompleteTimer}
                />
                <Content
                  orderId={this.state.params.refNo}
                  totalAmount={this.state.totalAmount}
                  paymentMethod="Akulaku"
                />
                {this.state.status === 1 ? (
                  <Text style={{ marginTop: "1rem", marginBottom: 0 }}>
                    Getting information from Akulaku. Please wait, this take a
                    while.
                  </Text>
                ) : null}
                {!isFromKickApp() ? (
                  <Link
                    style={{ marginTop: "1rem", cursor: "pointer" }}
                    className="btn-green bold btn btn-success btn-lg"
                    to="/"
                    title="Back to homepage"
                  >
                    BACK TO HOME
                  </Link>
                ) : null}
                <Text style={{ marginTop: "1rem", marginBottom: 0 }}>
                  If you have any questions about your order, please contact our
                  team by email to{" "}
                  <a
                    href="mailto:info@kickavenue.com"
                    title="Mail to info@kickavenue.com"
                  >
                    info@kickavenue.com
                  </a>
                  . Please put your invoice number into your subject email.
                </Text>
              </Box>
            </Col>
          </Row>
        </Container> */}

        <div id="akulaku-payment-result">
          <div className="akulaku-payment-result-wrapper">
            <div className="icon-wrapper">
              <KickImage src={this.getStatusIcon(this.state.status)} alt="Buy Now, Pay Later with Akulaku" width={100} style={{ margin: '20px auto' }} />
            </div>
            <div className="header-text-wrapper">
              <p>{getStatusText(this.state.status)}</p>
            </div>
            <div className="message-text-wrapper">
              {this.state.status === 1 ? (
                <p>
                  Getting information from Akulaku. Please wait, this take a
                  while.
                </p>
              ) : <p>If you have any questions about your order, please contact our
                team by email to{" "}
                <a
                  href="mailto:info@kickavenue.com"
                  title="Mail to info@kickavenue.com"
                >
                  info@kickavenue.com
                </a>
                . Please put your invoice number into your subject email.</p>}
            </div>
            {this.state.message && (
              <div className="referenceId-wrapper">
                <p>referenceId: {this.state.tr_id}</p>
                <p>reason: {this.state.message}</p>
              </div>
            )}
            {!isFromKickApp() &&
              <div className="button-wrapper">
                <div className="back-to-shopping-btn" onClick={() => this._handleGoHome()}><p>BACK TO HOME</p></div>
              </div>
            }
          </div>
        </div>
      </>
    );
  }
}
export default withScrollTo(PagePaymentAkulaku);
